var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('b-spinner',{staticStyle:{"width":"3rem","height":"3rem"}}),_c('hr'),_c('strong',[_vm._v(_vm._s(_vm.value))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }